import React from "react";
import { doc, setDoc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db, auth } from "./firebase";

export default function useOnlineStatus() {
  React.useEffect(() => {
    if (!auth.currentUser) return;

    const userStatusDoc = doc(db, "status", auth.currentUser.uid);

    const setOnline = async () => {
      await setDoc(
        userStatusDoc,
        {
          isOnline: true,
          lastSeen: serverTimestamp(),
        },
        { merge: true }
      );
    };

    const setOffline = async () => {
      await updateDoc(userStatusDoc, {
        isOnline: false,
        lastSeen: serverTimestamp(),
      });
    };

    // Set online immediately
    setOnline();

    // Periodically refresh online status (every 60s)
    const interval = setInterval(setOnline, 60000);

    // Update offline on tab close
    window.addEventListener("beforeunload", setOffline);

    return () => {
      setOffline();
      clearInterval(interval);
      window.removeEventListener("beforeunload", setOffline);
    };
  }, []);
}
